<template>
  <article class="accent-didi">
    <header>
      <h2>Post von Didi</h2>
    </header>
    <main>
      <p><strong>Möchtest du stets informiert bleiben, was die Party betrifft?</strong></p>
      <p>
        Trage dich einfach mit deiner E-Mail-Adresse ein und du erhältst von mir nach einer kurzen Bestätigung deiner
        E-Mail-Adresse aktuelle Informationen, z.B. zum Start des Ticketverkaufs. Damit solltest du zum Start der Party
        auf jeden Fall gewappnet sein!
      </p>
      <template v-if="success">
        <p><strong>Vielen Dank für dein Interesse! Sieh in deinem E-Mail Postfach nach (auch im Spam-Ordner!), und klicke
          auf den Link in der soeben von mir versendeten Bestätigungsmail</strong></p>
      </template>
      <template v-else>
        <div class="newsletter-signup" style="margin: 2em 0;">
          <label for="email">E-Mail-Adresse</label>
          <input id="email" type="email" v-model="email">
          <button v-if="signupValid" @click="submitNewsletterRegistration">Bestätigungsmail senden</button>
          <button v-else disabled>Bitte trage zuerst deine E-Mail-Adresse ein</button>
        </div>
        <div v-if="error">
          <p>Bei der Übermittlung ist ein Fehler aufgetreten:</p>
          <p>{{error}}</p>
        </div>
      </template>
    </main>
  </article>
</template>


<script>
  const axios = require('axios');
  export default {
    data() {
      return {
        email: null,
        success: null,
        error: null
      }
    },
    computed: {
      signupValid() {
        let re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])/;
        return this.email && this.email.match(re);
      }
    },
    methods: {
      submitNewsletterRegistration() {
        axios.post('https://contact.frechdax-abdl.de/api/newsletter/register', {
          email: this.email
        }).then(response => response.data)
             .then(() => {
               this.success = true;
             })
             .catch(error => {
               console.error(error);
               this.error = error.response.data;
             })
      }
    }
  }
</script>


<style scoped lang="scss">
  .newsletter-signup {
    display: grid;
    grid-template-columns: auto 1fr 1fr;
    grid-gap: 20px;
    align-items: center;

    @media screen and (max-width: 1000px) {
      display: block;

      > * {
        display: block;
        margin: 10px 0;
      }
    }
  }
</style>
